import React, { useState, useEffect } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { fetchData, updateData } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import Select from 'react-select';
import Button from '@mui/material/Button';
import { Link } from 'react-router-dom';
import CopyrightIcon from '@mui/icons-material/Copyright';
import CloseIcon from '@mui/icons-material/Close';

const UserDetail = () => {
    const { id } = useParams();
    const history = useHistory();

    const { isAuthenticated, companyId, userId, logout, permissions, token } = useAuth();

    useEffect(() => {
        // Check if the token is expired
        if (isAuthenticated && tokenIsExpired(token)) {
            // Token is expired, log out the user
            logout();
            return;
        }

    }, [isAuthenticated, companyId, token, logout]);
    const hasCreateAdministrationPermission = permissions.includes('Create Administration');
    const hasEditAdministrationPermission = permissions.includes('Edit Administration');
    const hasDeleteAdministrationPermission = permissions.includes('Delete Administration');

    const [isSavingRoles, setIsSavingRoles] = useState(false);
    const [isSavingClaims, setIsSavingClaims] = useState(false);
    const [selectedOption, setSelectedOption] = useState({ value: '1', label: 'Master' });

    const [isEditMode, setIsEditMode] = useState(false);
    const [isClaimEditMode, setIsClaimEditMode] = useState(false);

    const [formData, setFormData] = useState({
        FirstName: '',
        LastName: '',
        UserName: '',
        Email: '',
        ContactNumber: '',
        isSubmit: false,
        Roles: [],
    });

    const [formDataClaim, setFormDataClaim] = useState({
        FirstName: '',
        LastName: '',
        UserName: '',
        Email: '',
        ContactNumber: '',
        isSubmit: false,
        Claim: [],
    });

    const [successMessage, setSuccessMessage] = useState("");
    const [errorMessage, setErrorMessage] = useState("");

    useEffect(() => {
        fetchData('UserApi', `/UserEdit/${id}`, token)
            .then((response) => {
                if (response.responseCode === '1111') {
                    const { User } = response.response_data;
                    setFormData((prevFormData) => ({
                        ...prevFormData,
                        ...User,
                        Roles: response.response_data.Roles ? response.response_data.Roles.map((role) => ({ ...role })) : [],
                    }));
                    setFormDataClaim((prevFormDataClaim) => ({
                        ...prevFormDataClaim,
                        ...User,
                        Claim: response.response_data.Claims
                            ? response.response_data.Claims.map((claim) => ({ ...claim }))
                            : [],
                    }));
                }
            })
            .catch((error) => {
                console.error('Error fetching User Details:', error);
            });
    }, [id]);

    const handleChangeRole = (index) => {
        const updatedRoles = formData.Roles.map((role, i) => ({
            ...role,
            IsSelected: i === index ? !role.IsSelected : false,
        }));
        setFormData((prevFormData) => ({ ...prevFormData, Roles: updatedRoles }));
    };

    const getClaimRange = () => {
        const startIndex = (parseInt(selectedOption.value, 10) - 1) * 5;
        const endIndex = startIndex + 4;
        return { startIndex, endIndex };
    };

    const handleDropdownChange = (newSelectedOption) => {
        setSelectedOption(newSelectedOption);
    };

    const handleChange = (index) => {
        const updatedClaims = [...formDataClaim.Claim];
        updatedClaims[index].IsSelected = !updatedClaims[index].IsSelected;
        setFormDataClaim((prevFormDataClaim) => ({ ...prevFormDataClaim, Claim: updatedClaims }));
    };

    const handleManageRolesClick = () => {
        setIsEditMode(true);
    };

    const saveRoles = async () => {
        try {
            setIsSavingRoles(true); // Set loading state to true
            const response = await updateData('UserApi', `SaveUserRoles/tmp/${id}`, formData, token);

            if (response.responseCode === '1111') {
                setSuccessMessage('Roles saved successfully');
            } else {
                setErrorMessage('');
            }
            setIsEditMode(false);
            history.push(`/userDetail/${id}`);
        } catch (error) {
            console.error('Error saving roles:', error);
        }
        finally {
            setIsSavingRoles(false); // Reset loading state after API call completes
        }
    };

    const handleManageClaimsClick = () => {
        setIsClaimEditMode(true);
    };

    const saveClaims = async () => {
        try {
            setIsSavingClaims(true);
            const response = await updateData('UserApi', `SaveUserClaims/UpdateClaim/tmp/${id}`, formDataClaim, token);

            if (response.responseCode === '1111') {
                setSuccessMessage('Claim saved successfully');
            } else {
                setErrorMessage('');
            }
            setIsClaimEditMode(false);
            history.push(`/userDetail/${id}`);

        } catch (error) {
            console.error('Error saving Claim:', error);

        }
        finally {
            setIsSavingClaims(false); // Reset loading state after API call completes
        }
    };



    return (
        <div className="w-full max-w-sm container mt-6 mx-auto">

            <div className="w-full mb-2 flex">
                <h6 className='block uppercase tracking-wide text-black productHead flex-grow linkcolor' style={{ fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif' }}>User - Detail </h6>
                <Button
                    color="error"
                    component={Link}
                    to="/UserIndex"
                    className="linkcolor"
                    style={{ marginLeft: '8px', color: 'darkred', fontWeight: 'bolder' }}
                >
                    <CloseIcon style={{ color: 'darkred', fontWeight: 'bolder' }} /> BACK TO LIST
                </Button>
            </div>

            <div className="watermark">
                <CopyrightIcon /><b style={{ fontFamily: 'Script Bold Italic' }}>EFFTABS SOLUTIONS LLP</b>
            </div>
            {errorMessage && <p className="text-red-500">{errorMessage}</p>}
            {successMessage && <p className="text-green-500">{successMessage}</p>}

            <div className="w-full mb-4 flex">
                <div className="w-1/4 mr-2">
                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" >
                        First Name
                        <span className="text-red-500">*</span>
                    </label>
                    <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline "
                        value={formData.FirstName}
                        name='FirstName'
                        type="text" placeholder="Enter First Name"
                        maxLength={30}
                        readOnly
                    />
                </div>

                <div className="w-1/4 mr-2">
                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" >
                        Last Name
                        <span className="text-red-500">*</span>
                    </label>
                    <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline "
                        value={formData.LastName}
                        name='LastName'
                        type="text" placeholder="Enter Last Name"
                        maxLength={30}
                        readOnly
                    />
                </div>
                <div className="w-1/4 mr-2">
                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" >
                        User Name
                        <span className="text-red-500">*</span>
                    </label>
                    <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline "
                        value={formData.UserName}
                        name='UserName'
                        type="text" placeholder="Enter User Name"
                        readOnly
                    />
                </div>
                <div className="w-1/4 mr-2">
                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" >
                        Contact Number
                        <span className="text-red-500">*</span>
                    </label>
                    <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline "
                        value={formData.ContactNumber}
                        name='ContactNumber'
                        type="text" placeholder="Enter Contact Number"
                        maxLength={15}
                        readOnly
                    />
                </div>

                <div className="w-1/4 mr-2">
                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" >
                        Email
                        <span className="text-red-500">*</span>
                    </label>
                    <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline "
                        value={formData.Email}
                        name='Email'
                        type="text" placeholder="Enter Email"
                        maxLength={40}
                        readOnly
                    />
                </div>
            </div>

            <div className="w-full mb-4 flex">
                {/* User Claims */}
                <div className="w-1/4 mr-2">
                    <br />
                    <div className="card" style={{ maxWidth: '400px' }}> {/* Adjust the maxWidth as needed */}
                        <div className="card-header">
                            <h5 style={{ marginTop: '.5rem', fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif' }}>User Claims</h5>
                            {hasEditAdministrationPermission && (
                                <>
                                    {!isClaimEditMode && (
                                        <button
                                            onClick={handleManageClaimsClick}
                                            style={{ width: 'auto', float: 'right', marginTop: '-38px', fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif' }}
                                            className="btn btn-primary"
                                        >
                                            Manage Claims
                                        </button>
                                    )}
                                    {isClaimEditMode && (
                                        <button
                                            onClick={saveClaims}
                                            style={{ width: 'auto', float: 'right', marginTop: '-38px', fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif' }}
                                            className="btn btn-primary"
                                            disabled={isSavingClaims}
                                        >
                                            {isSavingClaims ? 'Saving Claims...' : 'Save Claims'}
                                        </button>
                                    )}
                                </>
                            )}


                        </div>
                        <div className="card-body">

                            <Select
                                options={[
                                    { value: '1', label: 'Master' },
                                    { value: '2', label: 'Transaction' },
                                    { value: '3', label: 'Accounts' },
                                    { value: '4', label: 'Reports' },
                                    { value: '5', label: 'Administration' },
                                ]}
                                value={selectedOption}
                                onChange={handleDropdownChange}
                                styles={{ fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif' }}
                            />
                            {formDataClaim.Claim && formDataClaim.Claim.length > 0 ? (
                                formDataClaim.Claim
                                    .map((claim, index) => {
                                        // Check if the claim should be included based on the selected dropdown option
                                        const shouldIncludeClaim = () => {
                                            const { startIndex, endIndex } = getClaimRange();
                                            return index >= startIndex && index <= endIndex;
                                        };

                                        // Only render the claim if it should be included
                                        if (shouldIncludeClaim()) {
                                            return (
                                                <div key={index} className="form-check m-1">
                                                    <label htmlFor={`claimCheckbox${index}`} className="text-black" style={{ fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif' }}>
                                                        {claim.ClaimValue}
                                                    </label>
                                                    <input type="hidden" name={`Claims[${index}].ClaimType`} value={claim.ClaimType} />
                                                    <input type="hidden" name={`Claims[${index}].ClaimValue`} value={claim.ClaimValue} />
                                                    <input type="hidden" name={`Claims[${index}].LogInClaims`} value={claim.LogInClaims} />
                                                    <input
                                                        type="checkbox"
                                                        name={`Claim[${index}].IsSelected`}
                                                        id={`claimCheckbox${index}`}
                                                        className="form-check-input"
                                                        checked={claim.IsSelected}
                                                        onChange={() => handleChange(index)}
                                                        style={{ border: '1px solid black' }}
                                                        disabled={!isClaimEditMode}
                                                    />
                                                </div>
                                            );
                                        }

                                        // Return null if the claim should not be included
                                        return null;
                                    })
                            ) : (
                                <p style={{ fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif' }}>No claims available.</p>
                            )}

                        </div>
                    </div>
                </div>

                {/* User Role */}
                <div className="w-1/4 mr-2">
                    <br />
                    <div className="card" style={{ maxWidth: '400px' }}> {/* Adjust the maxWidth as needed */}
                        <div className="card-header">
                            <h5 style={{ marginTop: '.5rem', fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif' }}>User Role</h5>
                            {hasEditAdministrationPermission && (

                                <>

                                    {!isEditMode && (
                                        <button
                                            onClick={handleManageRolesClick}
                                            style={{ width: 'auto', float: 'right', marginTop: '-38px', fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif' }}
                                            className="btn btn-primary"
                                        >
                                            Manage Roles
                                        </button>
                                    )}
                                    {isEditMode && (
                                        <button
                                            onClick={saveRoles}
                                            style={{ width: 'auto', float: 'right', marginTop: '-38px', fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif' }}
                                            className="btn btn-primary"
                                            disabled={isSavingRoles}
                                        >
                                            {isSavingRoles ? 'Saving Roles...' : 'Save Roles'}
                                        </button>
                                    )}

                                </>
                            )}
                        </div>
                        <div className="card-body">
                            {formData.Roles && formData.Roles.length > 0 ? (
                                formData.Roles
                                    .map((role, index) => {

                                        return (
                                            <div key={index} className="form-check m-1" style={{ fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif' }}>
                                                <label htmlFor={`roleCheckbox${index}`} className="text-black" style={{ fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif' }}>
                                                    {role.RoleName}
                                                </label>
                                                <input type="hidden" name={`Roles[${index}].RoleName`} value={role.RoleName} />
                                                <input type="hidden" name={`Roles[${index}].RoleId`} value={role.RoleId} />
                                                <input
                                                    type="checkbox"
                                                    name={`Roles[${index}].IsSelected`}
                                                    id={`roleCheckbox${index}`}
                                                    className="form-check-input"
                                                    checked={role.IsSelected}
                                                    onChange={() => handleChangeRole(index)}
                                                    style={{ border: '1px solid black' }}
                                                    disabled={!isEditMode}
                                                />
                                            </div>
                                        );
                                    })
                            ) : (
                                <p style={{ fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif' }}>No claims available.</p>
                            )}
                        </div>
                    </div>
                </div>



            </div>

        </div>
    );
};

export default UserDetail;
